// extracted by mini-css-extract-plugin
module.exports = {"ComponentHolder":"LoadingComponet_ComponentHolder__3j0DF"};